import React, { Component } from 'react';
import { observer } from "mobx-react";
import ProtocolRecordsStore from 'Stores/ProtocolRecords/protocolRecordsStore'
import FiltersStore from 'Stores/ProtocolRecords/FiltersStore';
import Checkbox from "Components/Common/checkbox";
import Sorting from "Utils/Sorting";
import AppStore from 'Stores/AppStore';
import Enumerable from "linq";

class RecordLineHeader extends Component {
    constructor() {
        super();
    }

    IsSortable(fieldName) {
        var filterProtocolSortingColumnWebNames = AppStore.productModeSettings?.filterProtocolSortingColumnWebNames;
        var filterProtocolSortingColumnWebNamesEnumerable = Enumerable.from(filterProtocolSortingColumnWebNames);

        var isSortable =
            filterProtocolSortingColumnWebNames == null || filterProtocolSortingColumnWebNamesEnumerable.any(it => it == fieldName)
            ;

        return isSortable;
    }

    GetSortOrderIcon(fieldName) {
        return (
            this.IsSortable(fieldName)
                ? Sorting.GetSortOrderIconParamValuesSort(FiltersStore.filters.sortRules, fieldName)
                : null
        );
    }

    SetSortOrderNext(fieldName) {
        if (this.IsSortable(fieldName)) {
            FiltersStore.filters.sortRules = Sorting.SetSortOrderNext(FiltersStore.filters.sortRules, fieldName);
            ProtocolRecordsStore.GetData();
        }
    }

    GetClassNameSortable(fieldName) {
        return (
            this.IsSortable(fieldName)
                ? "table-column-content-sortable"
                : ""
        );
    }

    render() {
        return (
            <div className={"record-line smr-table-line"}
                id={`record-line-header`}>
                <div className={"record-line-without-description header"}>
                    <div className="select-line-column">
                        <Checkbox
                            checked={(
                                ProtocolRecordsStore.records?.length > 0
                                &&
                                ProtocolRecordsStore.records?.every(itRecord => ProtocolRecordsStore.selectedRecordsIds.some(itSelectedRecordId => itRecord.id == itSelectedRecordId))
                            )}
                            onChange={(state) => ProtocolRecordsStore.SelectCurrentPageOfTable(state)} />
                    </div>
                    <div className={"reg-num-column-width " + this.GetClassNameSortable("regnum")} onClick={() => this.SetSortOrderNext("regnum")}>
                        №, ДАТА {this.GetSortOrderIcon("regnum")}
                    </div>
                    <div className={"user-column-width " + this.GetClassNameSortable("userdlfirst")} onClick={() => this.SetSortOrderNext("userdlfirst")}>
                        Пользователь {this.GetSortOrderIcon("userdlfirst")}
                    </div>
                    <div className={"action-column-width" + " " + this.GetClassNameSortable("actionname")} onClick={() => this.SetSortOrderNext("actionname")}>
                        Событие {this.GetSortOrderIcon("actionname")}
                    </div>
                    <div className="additional-info-button-column-width">
                    </div>
                    <div className={"start-date-column-width " + this.GetClassNameSortable("startdate")} onClick={() => this.SetSortOrderNext("startdate")}>
                        Время {this.GetSortOrderIcon("startdate")}
                    </div>
                </div>
            </div>
        );
    }
}

export default observer(RecordLineHeader);